import { Input } from 'antd';
import React from 'react';
import { FormRow } from './Form';
import { HelpText }
  from './typography';

export default ({ value, onChange }) => (
  <div style={({ padding: '1rem' })}>
    <FormRow labelSpan={6} height={300} label="Terms" tall={1}>
      <Input.TextArea
        id="spottingGroupEditingId"
        value={value}
        onChange={onChange}
        style={({ width: '100%', height: '100%' })}
      />
    </FormRow>
    <FormRow labelSpan={6} height={100} label="" tall={1}>
      <HelpText>
          enter &quot;term&quot;,<br />
          or &quot;term, weight&quot;,<br />
          or  &quot;term, weight, soundsLike, soundsLike &quot;
          on each row
      </HelpText>
    </FormRow>
  </div>
);
